/**
 * @ComponentFor Avensia.Common.ContentTypes.Media.ImageDataModel
 */
import React from 'react';
import { epiPropertyValue } from '@avensia/scope-episerver';
import Image from '../Image';
import ImageDataModelType from 'ContentTypes/Media/ImageDataModel.type';

export default (props: ImageDataModelType) => <Image src={epiPropertyValue(props.contentLink).url} />;
